import React from "react";
import Card from "../../../Card";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";

export default function CardAdminDashboardGeneral(props) {
    const renderContent = () => {
        return (
            <MUIGrid container spacing={2}>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={props.dashboard?.name ?? ""}
                        autoFocus={true}
                        size="small"
                        label="Name"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 255,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => props.onChange({ name: e.target.value.trim() })}
                        onChange={(e) => props.onChange({ name: e.target.value })}
                        required={true}
                        error={props.validationIssues.name ? true : false}
                        helperText={props.validationIssues.name ? props.validationIssues.name : ""}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={8}>
                    <MUITextField
                        value={props.dashboard?.description ?? ""}
                        size="small"
                        label="Description"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 1024,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => props.onChange({ description: e.target.value.trim() })}
                        onChange={(e) => props.onChange({ description: e.target.value })}
                        required={false}
                        error={props.validationIssues.description ? true : false}
                        helperText={props.validationIssues.description ? props.validationIssues.description : ""}
                    />
                </MUIGrid>
            </MUIGrid>
        );
    };

    return (
        <Card
            renderContent={renderContent}
            getTitle={() => "General"}
        />
    );
}
